angular.module('zc.zenclerkS')
  .factory('ZcsLayout', ZcsLayout);

ZcsLayout.$inject = [];
function ZcsLayout() {
  const service = {
    isSidebarVisible: false
  };
  return service;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/layout.service.js